<div class="company-profile">
  @if (loading()) {
    <app-paragraph-loader></app-paragraph-loader>
  } @else if (isFinnetDesktop()) {
    <app-v3-finnet-content-grid [items]="sections()"></app-v3-finnet-content-grid>
  } @else if (isZeroDesktop()) {
    <app-v3-zero-content-grid [items]="sections()"></app-v3-zero-content-grid>
  } @else {
    @for (section of sections(); track section.title) {
      @if (isFinnet()) {
        <div class="card">
          <h3 class="card-title">{{ section.title }}</h3>
          <p [innerHTML]="formatText(section.text) | textClean"></p>
        </div>
      } @else {
        <div class="section">
          <div class="section-title">
            <span class="notch"></span>
            <span>{{ section.title }}</span>
          </div>
          <div class="card">
            <p [innerHTML]="formatText(section.text) | textClean"></p>
          </div>
        </div>
      }
    }
  }
</div>
